export const INCOMPLETE = 'Please fill in all required fields correctly.'
export const SIMPLE_STRING = 'Can only contain letters, numbers, periods, underscores, and hyphens.'
export const CREATOR_NAME = 'This field is required.'
export const DATE_STRING = 'Must match date format YYYY-MM-DD.'
export const URL_STRING = 'Must be a URL starting with http or https.'
export const ISBN = 'Can contain only numbers and hyphens and must be fewer than 17 characters. If you cut-and-pasted the ISBN, it may contain hidden whitespace characters.'
